import React, { useContext, useEffect, useState } from "react";
import discountimg from "../../../src/assets/images/Discount-warrantyclaim.svg";
import jclabor from "../../../src/assets/images/Discount-JC labor.svg";
import jcpart from "../../../src/assets/images/Discount-JC Part.svg";
import frames from "../../../src/assets/images/Frames.svg";
import { FilterContext } from "../../context/Filter";
import axios from "axios";
import { axInst } from "../Login/Service";
import { axInstBasic } from "../Service/Service";

const formatInThousands = (num) => {
  if (num === null || num === undefined) return "₹0.00 K";
  return `₹${(num / 1000).toFixed(2)} K`;
};

const Claimcard = () => {
  const [warrantyVasMainBlock, setwarrantyVasMainBlock] = useState(null);
  const [jcdpart, setjcdpart] = useState(null);
  const [jcdlabour, setjcdlabour] = useState(null);
  const [error, setError] = useState(null);
  const [claimpopdata, setClaimpopdata] = useState([])

  const { arn: parArn, childArn } = useContext(FilterContext);

  const fetchwarrantyVasMainBlock = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}warrantyVasMainBlock`,
        { parArn, childArn }
      );
      setwarrantyVasMainBlock(res.data);
      return res.data;
    } catch (error) {
      console.error("API fetch error:", error);
      return null;
    }
  };

  const fetchJcdlabour = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}jcdlabour`,
        { parArn, childArn }
      );
      setjcdlabour(res.data);
      return res.data;
    } catch (error) {
      console.error("API fetch error:", error);
      return null;
    }
  };

  const fetchJcdpart = async () => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}jcdpart`, {
        parArn,
        childArn,
      });
      setjcdpart(res.data);
      return res.data;
    } catch (error) {
      console.error("API fetch error:", error);
      return null;
    }
  };

  useEffect(() => {
    fetchwarrantyVasMainBlock();
    fetchJcdlabour();
    fetchJcdpart();
  }, [parArn, childArn]);

  return (
    <div className="flex m-4 justify-center md: flex ">
      <div className=" bg-[#E0F7E9] flex col rounded-md">
        <div className=" w-36  lex gap-2 border rounded-md">
          <div className=" flex-col justify-center justify-items-center rounded-md">
            <h1 className="text-xs font-semibold justify-center justify-items-center mt-5  ">
              {" "}
              Warranty Claims Amount{" "}
            </h1>
            <h1 className="text-xs justify-center justify-items-center font-semibold pb-1 text-[#233D91]">
              {warrantyVasMainBlock?.result !== undefined
                ? Number(
                    warrantyVasMainBlock.result?.value / 1000
                  ).toFixed(2) +
                  " " +
                  "K"
                : "0"}
            </h1>

            <img src={discountimg} alt="" />
          </div>
        </div>
      </div>

      {/* JC Part & Labour Discounts */}
      <div className="flex flex-col gap-2">
        {/* JC Part Discount */}
        <div className="m-1 bg-[#E0F7E9] flex w-52 h-15 p-4 gap-4 border rounded-md items-center">
          <img src={jclabor} alt="JC Labour" />
          <div>
            <h1 className="text-xs font-semibold  ">
              JC Part Discount{" "}
              <h1 className="text-[#233D91] text-xs">
                {jcdlabour?.result !== undefined
                  ? Math.ceil(Number(jcdpart?.result) / 1000).toFixed(2) + " K"
                  : ""}
              </h1>
            </h1>
          </div>
        </div>

        {/* JC Labour Discount */}
        <div className="m-1 bg-[#E0F7E9] flex w-52 h-15 p-4 gap-4 border rounded-md items-center">
          <img src={frames} alt="Frames" />
          <div>
            <img src={frames} />
          </div>
          <div>
            <h1 className="text-xs font-semibold">
              JC Labour Discount{" "}
              <h1 className="text-xs text-[#233D91]">
                {jcdlabour?.result
                  ? `${(jcdlabour.result / 1000).toFixed(2)} K`
                  : "0 K"}
              </h1>
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Claimcard;
